import React from 'react';  
import { Link, useLocation } from 'react-router-dom';  
import { FaHome, FaRobot, FaDatabase } from 'react-icons/fa'; // FaCog を追加  
import { MdAreaChart } from "react-icons/md";  

// 環境変数からデモモードを判断    
const isDemoMode = (process.env.REACT_APP_DEMO_MODE || 'false') === 'true';   
  
const TabNavigation = ({ onNavClick }) => {  
  const location = useLocation();  
  
  const navStyle = {  
    display: 'flex',  
    justifyContent: 'space-around',  
    alignItems: 'center',  
    height: '60px',  
    backgroundColor: '#FFFFFF',  
    boxShadow: '0 -1px 6px rgba(0, 0, 0, 0.1)',  
    position: 'fixed',  
    bottom: 0,  
    left: 0,  
    width: '100%',  
    zIndex: 1000,  
  };  
  
  const linkStyle = (path) => ({  
    color: location.pathname === path ? '#007C3E' : '#8e8e8e',  
    textDecoration: 'none',  
    display: 'flex',  
    flexDirection: 'column',  
    alignItems: 'center',  
    fontSize: '14px',  
  });  
  
  return (  
    <div style={navStyle}>  
      <Link to="/farm" style={linkStyle('/farm')} onClick={onNavClick}>  
        <FaHome size={24} />  
        <span>農場</span>  
      </Link>  
      <Link to="/robots" style={linkStyle('/robots')} onClick={onNavClick}>  
        <FaRobot size={24} />  
        <span>ロボ</span>  
      </Link>  
      <Link to="/market-data" style={linkStyle('/market-data')} onClick={onNavClick}>  
        <MdAreaChart size={24} />  
        <span>市況</span>  
      </Link>  
      {!isDemoMode && (  // ここで条件付きレンダリングを行う
      <Link to="/data-base" style={linkStyle('/data-base')} onClick={onNavClick}> {/* 設定リンクを追加 */}  
        <FaDatabase size={24} />  
        <span>DB</span>  
      </Link>  
      )}
    </div>  
  );  
};  
  
export default TabNavigation;  